var Parse = require("ParseInit");

var AgeType = Parse.Object.extend("ageType", {
    col: {
        ACL: "ACL",
        code: "code",
        createdAt: "createdAt",
        description: "description",
        editor: "editor",
        ages: "ages",
        mainGroupPlaceID: "mainGroupPlaceID",
        name: "name",
        objectId: "objectId",
        sortIndex: "sortIndex",
        status: "status",
        unions: "unions",
        updatedAt: "updatedAt",
    },
    getSelectString() {
        return this.getName() + ", " + this.getDescription()
    },
    isDeleted() {
        return "D" === this.getStatus();
    },
    isWithinAges(tournamentAge) {
        const ages = this.getAges();
        if (ages != null && ages.length > 1) {
            return tournamentAge >= ages[0] && tournamentAge <= ages[1]
        }
        return false
    },
    getACL() {
        return this.get(this.col.ACL)
    },
    setACL(ACL) {
        return this.set(this.col.ACL, ACL)
    },
    getCode() {
        return this.get(this.col.code)
    },
    setCode(code) {
        return this.set(this.col.code, code)
    },
    getCreatedAt() {
        return this.get(this.col.createdAt)
    },
    getDescription() {
        return this.get(this.col.description)
    },
    setDescription(description) {
        return this.set(this.col.description, description)
    },
    getEditor() {
        return this.get(this.col.editor)
    },
    setEditor(editor) {
        return this.set(this.col.editor, editor)
    },
    getAges() {
        return this.get(this.col.ages)
    },
    getMainGroupPlaceID() {
        return this.get(this.col.mainGroupPlaceID)
    },
    setMainGroupPlaceID(mainGroupPlaceID) {
        return this.set(this.col.mainGroupPlaceID, mainGroupPlaceID)
    },
    getName() {
        return this.get(this.col.name)
    },
    setName(name) {
        return this.set(this.col.name, name)
    },
    getObjectId() {
        return this.get(this.col.objectId)
    },
    setObjectId(objectId) {
        return this.set(this.col.objectId, objectId)
    },
    getSortIndex() {
        return this.get(this.col.sortIndex)
    },
    setSortIndex(sortIndex) {
        return this.set(this.col.sortIndex, sortIndex)
    },
    getStatus() {
        return this.get(this.col.status)
    },
    setStatus(status) {
        return this.set(this.col.status, status)
    },
    getUnions() {
        return this.get(this.col.unions)
    },
    setUnions(unions) {
        return this.set(this.col.unions, unions)
    },
    getUpdatedAt() {
        return this.get(this.col.updatedAt)
    },
});

module.exports = AgeType;
